import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Fade, Popover } from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'

import { find, get } from 'lodash'

import VisitRangeMenu from './VisitRangeMenu'
import ranges from './ranges'

const getRangeTypeString = ({ rangeType, to, from }) => {
  const selectedRange = find(ranges, { value: rangeType })
  if (get(selectedRange, 'value') !== 'custom') {
    return selectedRange.label
  }
  if (to && from) {
    if (to.format && from.format) {
      return `${from.format('MM/DD/YYYY')} - ${to.format('MM/DD/YYYY')}`
    } else return `${to} - ${from}`
  }
  return ''
}

const VisitRangeFilter = ({ onChange, from, to, rangeType }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const onRangeChange = (from, to, rangeType) => {
    setAnchorEl(null)
    onChange({
      from,
      to,
      type: rangeType,
    })
  }
  return (
    <div>
      <Button
        color="primary"
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-haspopup="true"
        aria-controls="visit-range-menu"
      >
        {!rangeType && (
          <span>
            Availability &nbsp;
            <FontAwesomeIcon icon={faCaretDown} />
          </span>
        )}
        {rangeType && getRangeTypeString({ rangeType, to, from })}
      </Button>
      <Popover
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        id="visit-range-menu"
        keepMounted
        getContentAnchorEl={null}
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <VisitRangeMenu
          rangeType={rangeType}
          range={{
            from: from,
            to: to,
          }}
          onRangeChange={(...args) => onRangeChange(...args)}
          onRangeClear={() => onRangeChange()}
        />
      </Popover>
    </div>
  )
}

VisitRangeFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  from: PropTypes.object,
  to: PropTypes.object,
  rangeType: VisitRangeMenu.propTypes.rangeType,
}

export default VisitRangeFilter
